import { Navigate } from 'react-router-dom'
import { lazyWithChunkRetry } from './lazyWithChunkRetry'

const Login = lazyWithChunkRetry(() => import('../pages/Authentication/Login'))
const Logout = lazyWithChunkRetry(() => import('../pages/Authentication/Logout'))
const Basic404 = lazyWithChunkRetry(() => import('../pages/AuthenticationInner/Errors/404'))
const Error500 = lazyWithChunkRetry(() => import('../pages/AuthenticationInner/Errors/500'))
const Dashboard = lazyWithChunkRetry(() => import('../pages/Dashboard'))
const UserProfile = lazyWithChunkRetry(() => import('../pages/Authentication/user-profile'))
const AdminInfo = lazyWithChunkRetry(() => import('pages/AdminInfo'))
const StaffInfo = lazyWithChunkRetry(() => import('pages/StaffInfo'))

const authProtectedRoutes = [
 { path: '/', component: <Dashboard /> },
 { path: '/profile', component: <UserProfile /> },
 { path: '/my-info/admin', component: <AdminInfo /> },
 { path: '/my-info/staff', component: <StaffInfo /> },
 { path: '*', component: <Navigate to="/404"/> },
]

const IntelligenceVisualQa = lazyWithChunkRetry(() => import('../pages/Intelligence/IntelligenceVisualQa'))

const publicRoutes = [
 { path: '/logout', component: <Logout /> },
 { path: '/login', component: <Login /> },
 { path: '/404', component: <Basic404 /> },
 { path: '/500', component: <Error500 /> },
 ...(process.env.NODE_ENV === 'development'
  ? [{ path: '/dev/intelligence-visual', component: <IntelligenceVisualQa /> }]
  : []),
]

export { authProtectedRoutes, publicRoutes }
